import * as React from 'react';

interface Props {
  translations: any;
  loadCatalogues: () => Promise<any>;
  loadingContainer: any;
  children: any;
}

interface State {
  translations: any;
}

class LanguageProvider extends React.PureComponent<Props, State> {
  public static translations: any;

  constructor(props) {
    super(props);
    LanguageProvider.translations = props.translations;
    this.state = {
      translations: props.translations,
    };
  }

  public async componentDidMount() {
    if (!this.props.translations) {
      const translations = await this.props.loadCatalogues();
      LanguageProvider.translations = translations;
      this.setState({ translations });
    }
  }

  public render() {
    if (this.state.translations) {
      return this.props.children;
    } else {
      return this.props.loadingContainer;
    }
  }
}

export { LanguageProvider };
